var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarkerGatewayOnline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 156,
    viewBox: "0 0 128 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-30%",
    y: "-20%",
    width: "160%",
    height: "160%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 2,
    dy: 5,
    stdDeviation: 4,
    floodOpacity: 0.24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 5C30.98 5 5 30.98 5 64C5 98.48 38.38 128.62 60.55 149.24C62.52 151.07 63.51 151.99 64 151.99C64.49 151.99 65.48 151.07 67.45 149.24C89.62 128.62 123 98.48 123 64C123 30.98 97.02 5 64 5Z",
    fill: "#20C537"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 57C39.05 47.95 51.01 43.42 64 43.42C76.99 43.42 88.95 47.95 98 57",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5 68.5C47.65 62.35 55.65 59.27 64 59.27C72.35 59.27 80.35 62.35 86.5 68.5",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5 80C55.67 76.83 59.7 75.25 64 75.25C68.3 75.25 72.33 76.83 75.5 80",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 91,
    r: 5.5,
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerGatewayOnline);
export default __webpack_public_path__ + "static/media/markerGatewayOnline.fe1c64ef9745d739a51bae429445acbb.svg";
export { ForwardRef as ReactComponent };